// Author : Ayesha Shaikg
//  Date : 02 aug 2024

import { useTheme } from "@emotion/react";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Radio,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import NewCardcomp from "../../../components/card/NewCardcomp";
import CustomAutocompleteComp from "../../../newTestPrep/newComponent/AutocompleteComp";
import CustomTextFieldComp from "../../../newTestPrep/newComponent/customTextFieldComp";

export default function GreGmatSatComp({
  handleCriteria,
  formData,
  handleChange,
  classType,
  trainerName,
  loading,
  handleChangeTrainer,
  trainerSlots,
  setSelectedClassData,
  trainerList,
  handleBookDemo,
  ButtonName,
  rescheduleReason,
  rescheduleReasons,
  setRescheduleReason,
}) {
  const theme = useTheme();
  return (
    <>
      <Grid item xs={12} lg={12}>
        <Button
          size="small"
          onClick={() => handleCriteria("date")}
          style={{
            color: classType === "date" ? "white" : "black",
            background: classType === "date" ? "#2196F3" : "",
            border: classType !== "date" ? "0.3px solid #A6A6A6" : "",
          }}
        >
          Search Demo Dates
        </Button>

        <Button
          onClick={() => handleCriteria("manual")}
          size="small"
          style={{
            marginLeft: "10px",
            color: classType === "manual" ? "white" : "black",
            background: classType === "manual" ? "#2196F3" : "",
            border: classType !== "manual" ? "0.3px solid #A6A6A6" : "",
          }}
        >
          Manual Demo Time
        </Button>
      </Grid>

      {classType === "date" ? (
        <>
          {trainerSlots.length !== 0 && (
            <Grid item xs={12}>
              <Typography variant="h4">
                Demo Slots Available for {formData.demo_date}
              </Typography>
            </Grid>
          )}

          <Grid item xs={12} textAlign="center">
            {loading && <CircularProgress />}
          </Grid>

          <Grid
            item
            xs={12}
            textAlign="center"
            sx={{
              display: "flex !important",
              flexDirection: "column !important",
              marginBottom: "1rem",
              marginTop: "1rem",
              width: "100%",
            }}
          >
            {trainerSlots.length === 0 ? (
              <Typography textAlign="center">
                No slots found for the selected criteria.
              </Typography>
            ) : (
              <Grid container spacing={2}>
                {trainerSlots.map((slot, index) => (
                  <Grid item xs={6} key={slot.id} lg={4} md={4} sm={6}>
                    <NewCardcomp
                      background="#f6f8fa"
                      padding="15px"
                      hoverBgColor={index % 2 === 0 ? "#D5F6E1" : "#FFEDFB"}
                      onclickEffect={formData.selectedSlot === slot.class_id}
                      hoverEffect={slot.available_slot > 0} // Disable hover if not available
                      style={{
                        opacity: slot.available_slot === 0 ? 0.6 : 1,
                        pointerEvents:
                          slot.available_slot === 0 ? "none" : "auto",
                      }}
                      onClick={() => {
                        if (slot.available_slot > 0) {
                          handleChange({
                            target: {
                              name: "selectedSlot",
                              value: slot.class_id,
                            },
                          });

                          const selectedClassData = {
                            slot: slot.slots,
                            trainer_id: slot.trainer_id.id,
                          };
                          setSelectedClassData(selectedClassData);
                        }
                      }}
                    >
                      {/* <Typography variant="h4">
                        Class Name: {slot?.class_name}
                      </Typography> */}
                      <Typography variant="h5">
                        Trainer: {slot.trainer_id?.first_name}
                      </Typography>
                      <Typography variant="body2">
                        Slot: {slot.slots}
                      </Typography>
                      <Typography variant="body2">
                        Class Days:{" "}
                        {slot.day?.map((i) => i.week_short_name).join(", ")}
                      </Typography>
                      {/* <FormControlLabel
                        control={
                          <Radio
                            checked={formData.selectedSlot === slot.class_id}
                            onChange={() => {
                              handleChange({
                                target: {
                                  name: "selectedSlot",
                                  value: slot.class_id,
                                },
                              });

                              const selectedClassData = {
                                slot: slot.slots,
                                trainer_id: slot.trainer_id.id,
                              };
                              setSelectedClassData(selectedClassData);
                            }}
                            value={slot.class_id}
                            name="selectedSlot"
                               disabled={slot.available_slot === 0} // disable radio
                          />
                        }
                        label="Select"
                      /> */}
                    </NewCardcomp>
                  </Grid>
                ))}
              </Grid>
            )}
          </Grid>
        </>
      ) : (
        <>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} lg={4}>
                <Typography>
                  Select Trainer{" "}
                  <span
                    style={{
                      color: "red",
                      position: "absolute",
                      marginLeft: "4px",
                      fontSize: "1em",
                    }}
                  >
                    *
                  </span>
                </Typography>

                <CustomAutocompleteComp
                  size="small"
                  disablePortal
                  value={trainerName}
                  onChange={handleChangeTrainer}
                  options={trainerList}
                  getOptionLabel={(option) =>
                    `${option.first_name ? option.first_name : ""} ${
                      option.last_name ? option.last_name : ""
                    }`
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                        // Add borderRadius here
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} lg={4}>
                <Typography>
                  Start Time{" "}
                  <span
                    style={{
                      color: "red",
                      position: "absolute",
                      marginLeft: "4px",
                      fontSize: "1em",
                    }}
                  >
                    *
                  </span>
                </Typography>
                <CustomTextFieldComp
                  value={formData.fromTime}
                  name="fromTime"
                  onChange={handleChange}
                  size="normal"
                  fullWidth
                  type="time"
                  InputProps={{ style: { borderRadius: "10px" } }}
                />
              </Grid>

              <Grid item xs={12} lg={4}>
                <Typography>
                  Duration{" "}
                  <span
                    style={{
                      color: "red",
                      position: "absolute",
                      marginLeft: "4px",
                      fontSize: "1em",
                    }}
                  >
                    *
                  </span>
                </Typography>

                <Select
                  fullWidth
                  size="normal"
                  name="duration"
                  onChange={handleChange}
                  value={formData.duration}
                  style={{ borderRadius: "10px" }}
                >
                  <MenuItem value={30}>30 Minutes</MenuItem>
                  <MenuItem value={60}>60 Minutes</MenuItem>
                  <MenuItem value={90}>90 Minutes</MenuItem>
                </Select>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}

      {ButtonName === "Reschedule Demo" && (
        <Grid item xs={12} lg={12}>
          <FormControl fullWidth>
            <Typography>
              Reason for reschedule{" "}
              <span
                style={{
                  color: "red",
                  position: "absolute",
                  marginLeft: "4px",
                  fontSize: "1em",
                }}
              >
                *
              </span>
            </Typography>
            <Select
              size="normal"
              name="rescheduleReason"
              value={rescheduleReason}
              onChange={(event) => setRescheduleReason(event.target.value)}
              style={{ borderRadius: "10px" }}
            >
              {rescheduleReasons.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.reschedule_reason}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      )}

      {/* Additional note */}
      <Grid item xs={12}>
        <Typography>Note (Optional)</Typography>
        <TextField
          name="note"
          placeholder="Type Anything..."
          variant="outlined"
          fullWidth
          value={formData.note}
          onChange={handleChange}
          multiline
          rows={4}
          InputProps={{ style: { borderRadius: "10px" } }}
        />
      </Grid>

      {/* book demo button base on date or manual  */}
      {classType === "date" ? (
        <Grid item xs={12} textAlign="end">
          <Button
            variant="contained"
            color="primary"
            onClick={handleBookDemo}
            disabled={!formData.selectedSlot}
          >
            {ButtonName}
          </Button>
        </Grid>
      ) : (
        <Grid item xs={12} textAlign="end">
          <Button
            variant="contained"
            color="primary"
            onClick={handleBookDemo}
            disabled={
              formData.fromTime === null ||
              formData.duration === null ||
              trainerName === null ||
              formData.demo_date === null
            }
          >
            {ButtonName}
          </Button>
        </Grid>
      )}
    </>
  );
}
